import { useQueryClient } from '@tanstack/react-query';

export const useRefetchQuery = () => {
  const queryClient = useQueryClient();

  const handleRefectQuery = ({ detail }) => {
    if (Array.isArray(detail?.queryKey)) {
      detail?.queryKey.forEach((key) => {
        queryClient.invalidateQueries({
          queryKey: [`${key}`],
        });
      });
    } else {
      queryClient.invalidateQueries({
        queryKey: [`${detail.queryKey}`],
      });
    }
  };
  
  return { handleRefectQuery };
};
